module.exports = __webpack_public_path__ + "img/harbinger-of-dawn.d4d25063.webp";